// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.transferred,\n.el-table th.transferred {\n  width: 6em;\n}", ""]);
// Exports
module.exports = exports;
